<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    autocomplete="off"
  >
  <v-card :loading="loading"  class="loginForm" width="500px">
      <div v-if="avatar" class="avatar-flip">
        <img :src="avatar" height="120" width="120">
        <img :src="logo" height="120" width="120 v-if">
      </div>
      <v-card-title class="grey--text  pl-1 ml-5" v-if="!avatar">
      <img class="login-logo center  mt-5 mr-4" src="/img/logo.png" width="50">
          <span class="mt-5">Nederlands<b>Kennis</b>Centrum</span>
      </v-card-title>
      <v-card-title class="grey--text text--darken-2 center">
      <div width="100%"><center>{{name}}</center></div>
    </v-card-title>
            <v-card-text v-if="!token" class="mt-5">
          
            <v-text-field v-show="!name" class="pl-2" v-model="email" label="Gebruikersnaam" prepend-icon="mdi-account-circle" name="email" placeholder="Email" type="email" :rules="[rules.required ,rules.emailRule]"></v-text-field>
              <v-text-field
                :append-icon="showPass ? 'visibility' : 'visibility_off'"
                :rules="[rules.required]"
                :type="showPass ? 'text' : 'password'"
                name="pass"
                v-model="pass"
                placeholder="Wachtwoord"
                
                value=""
                label="Wachtwoord"
                 prepend-icon="mdi-lock"
                @click:append="showPass = !showPass"
                  @keyup.enter.native="doLogin"
                  class="pl-2"
              ></v-text-field>
      

        </v-card-text>
         <v-card-actions>
           <v-btn  v-if="!token && name" @click="cancel" text>Andere gebruiker</v-btn>
           <v-spacer></v-spacer>
           <v-btn  v-if="!token" color="primary" @click="doLogin">Inloggen</v-btn>
         </v-card-actions>
      </v-card>
     
  </v-form>
</template>

<script>
import {
  mapActions, mapMutations
} from 'vuex'
  export default {
    data: () => ({
      loading: false,
      message: '',
      valid: false,
      email: null,
      pass: null,
      showPass: false,
      user: {},
      rules: {
          required: value => !!value || 'Verplicht.',
          emailRule: v => /.+@.+/.test(v) || 'Vul een geldig E-mail adres in',
          min: v => v.length >= 8 || 'Minimaal 8 characters',
          emailMatch: () => ('Het E-mail adres of wachtwoord wordt niet herkend')
        }
    }),
    computed: {
        avatar (){
          return this.user.avatar
        },
        logo (){
          return this.user.logo
        },
        name (){
          return this.user.name
        },
        token () {
          return this.$router.currentRoute.query.token
        },
        redir () {
          return this.$router.currentRoute.query.redir || '/'
        }
    },
     mounted () {
       this.$cookies.config('30d')
       if (this.$cookies.get('user')) this.user = this.$cookies.get('user')
        this.$cookies.remove("user");
      if (this.token) {
        this.loading = true
        this.setDeeplink(true)
        this.login({token: this.token})
        let query = Object.assign({}, this.$route.query);
        delete query.token;
        this.$router.replace({ query });
        //this.$router.replace({'query': null});
      }
    },
    sockets: {
      authentication (settings) {
        this.loading = false
        settings._user.logo = settings.relation.logo || settings._user.avatar
        this.$cookies.set('user',settings._user)
        //.$router.push(this.redir)
        //this.$emit('close')
      },
      socket_invalid_login () {
        this.loading = false
        this.$emit("message", 'Ongeldige login')
      }
    },
    methods: {
      ...mapActions('auth', ['login','authenticated']),
      ...mapMutations('app', ['setDeeplink']),
      validate () {
        return this.$refs.form.validate()
      },
      cancel () {
        this.user = {}
        this.$refs.form.reset()
        this.$refs.form.resetValidation()
      },
      doLogin() {
        var self = this
        this.loading = true
        setTimeout(() => { self.loading = false}, 3000)
        if (this.validate()) {
          this.$cookies.remove("user");
          this.login({user: this.email, pass: this.pass})
          
          //this.$emit('close')
        }
      }
    }
  }
</script>
<style>
.loginForm {
  text-align: center;
}
.loginForm.v-card--loading {
    overflow:inherit;
}
.avatar-flip:hover {
  transform: rotateY(180deg);
  -webkit-transform: rotateY(180deg);
}
.avatar-flip:hover img:first-child {
  opacity: 0;
}
.avatar-flip:hover img:last-child {
  opacity: 1;
}
  .avatar-flip {
  border-radius: 80px;
  overflow: hidden;
  height: 120px;
  width: 120px;
  position: relative;
  margin: auto;
  top: -50px;
  margin-bottom: -30px;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  box-shadow: 0 0 0 8px #f0f0f0;
  -webkit-box-shadow: 0 0 0 8px #f0f0f0;
  -moz-box-shadow: 0 0 0 8px #f0f0f0;
  z-index: 10;
  opacity:1!important;
}
.avatar-flip img {
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 80px;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
}
.avatar-flip img:first-child {
  z-index: 1;
}
.avatar-flip img:last-child {
  z-index: 0;
  transform: rotateY(180deg);
  -webkit-transform: rotateY(180deg);
  opacity: 0;
}
.loginForm input:-webkit-autofill {
    -webkit-box-shadow:0 0 0 50px white inset; /* Change the color to your own background color */
    -webkit-text-fill-color: #333;
}

.loginForm input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 50px white inset;/*your box-shadow*/
    -webkit-text-fill-color: #333;
} 
.v-card__title.center {
  justify-content: center;
}
</style>